<!-- <app-pccrud [endPoint]="'DrugGroup'"></app-pccrud> -->
<app-pcbread-crumb [data]="'Pharmacy,DrugGroup'"></app-pcbread-crumb>

<div class="card p-2 animate__animated animate__backInDown">
  <app-pctable-action
    [data]="action"
    [header]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable-action>

  <app-pctable
    [data]="data"
    [urlName]="'columnsArray_DrugGroup'"
    [entityField]="fields"
    (parentAction)="parentAction($event)"
  >
  </app-pctable>

  <app-pcpaging [paging]="paging" (parentAction)="parentAction($event)">
  </app-pcpaging>

  <app-loading-panel *ngIf="loading"> </app-loading-panel>
</div>

<app-pcsetting-modal
  (parentAction)="parentAction($event)"
  [fields]="fields"
>
</app-pcsetting-modal>

<app-pcedit-modal
  [modalIsOpen]="openAddModal"
  [inputFields]="fields"
  [editSource]="thisValue"
  (parentAction)="parentAction($event)"
>
</app-pcedit-modal>

<app-pcconfrim-modal
  *ngIf="modalDeleteConfirm"
  (childEvent)="parentAction($event)"
  [inputModel]="confirmModal"
>
</app-pcconfrim-modal>

<ng-template #addSearchDrug let-modal class="modal modal-top fade">
  <div class="modal-header border-bottom p-3">
    <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
      {{ "AddDrugTitle" | translate }}
    </h6>
    <button
      type="button"
      class="btn-close-modal btn-icon btn-close"
      (click)="modal.dismiss('Cross click')"
      aria-label="Close"
    ></button>
  </div>

  <ng-container *ngIf="confirmItemDelete; else elseTemplate">
  
      <div
        class="swal2-icon swal2-warning swal2-icon-show"
        style="display: flex"
      >
        <div class="swal2-icon-content">!</div>
      </div>
      <img class="swal2-image" style="display: none" />
      <h2 class="swal2-title" id="swal2-title" style="display: block">
        {{ "DeleteTitle" | translate }}
      </h2>
      <div
        class="swal2-html-container"
        id="swal2-html-container"
        style="display: block"
      >
        {{ "DeleteMessage" | translate }}
      </div>
      <div class="swal2-actions">
        <div class="swal2-loader"></div>
        <button
          type="button"
          class="swal2-confirm btn btn-primary me-3"
          style="display: inline-block"
          aria-label=""
          (click)="deleteRow()"
        >
          {{ "ConfirmButton" | translate }}
        </button>
        <button
          type="button"
          class="swal2-deny"
          style="display: none"
          aria-label=""
        >
          {{ "No" | translate }}
        </button>
        <button
          type="button"
          class="swal2-cancel btn btn-label-secondary"
          style="display: inline-block"
          aria-label=""
          (click)="confirmItemDelete = false"
        >
          {{ "Cancel" | translate }}
        </button>
      </div>
  </ng-container>
  <ng-template #elseTemplate>
    <div class="modal-body border-bottom card">
      <app-pctable
        #SecondPCTableComponent
        [urlName]="'columnsArray_InsideDrugGroup'"
        [data]="dataDetails"
        [entityField]="childFields"
        [inlineEdit]="false"
        [loadInside]="true"
        (parentAction)="parentActionItem($event)"
      >
      </app-pctable>
      <app-pcpaging
        [paging]="pagingDetails"
        (parentAction)="parentActionItem($event)"
      >
      </app-pcpaging>

      <div class="add-box">
        <form [formGroup]="drugSearchForm">
          <input
            id="drugBrandName"
            type="text"
            autocomplete="off"
            appSelectOnFocus
            formControlName="drugBrandName"
            class="form-control Focusable iner-Focusable search-input-box"
            placeholder="{{ 'searchPreInvoice' | translate }}"
            [(ngModel)]="editableItem.drugName"
            (keyup.escape)="modalIsOpen = false"
          />
        </form>

        <app-search-box
          [data]="searchData"
          [addButton]="true"
          [fields]="searchFields"
          [urlName]="'columnsArray_BuySearch'"
          [paging]="searchPaging"
          [modalIsOpen]="modalIsOpen"
          (parentAction)="parentSearchAction($event)"
        ></app-search-box>
      </div>
    </div>
  </ng-template>
  <div class="modal-footer order-bottom p-3"></div>

  <app-pcsuccess-modal
    [showModal]="modalSuccessConfirm"
    (parentAction)="parentAction($event)"
  >
  </app-pcsuccess-modal>
</ng-template>
